import { FilterReplacementStatus } from 'common';

import { Status } from '../types/Status';

export const mapFilterReplacementStatusToStatus = (
  filterReplacementStatus: FilterReplacementStatus | null,
): Status => {
  switch (filterReplacementStatus) {
    case FilterReplacementStatus.FilterChangeUpcoming:
      return Status.Poor;
    case FilterReplacementStatus.FilterChangeOverdue:
      return Status.Error;
    case FilterReplacementStatus.HVACFilterAlert:
      return Status.Error;
    case FilterReplacementStatus.ServiceRequested:
      return Status.Poor;
    case FilterReplacementStatus.FilterOrdered:
      return Status.Good;
    case FilterReplacementStatus.NoFilterChangeNeeded:
      return Status.Good;
    default:
      return Status.Good;
  }
};

export const mapFilterReplacementStatusToText = (
  filterReplacementStatus: FilterReplacementStatus | null,
  filterHealthPercentage: number | null,
  t: (key: string) => string,
): string => {
  const percentageText =
    filterHealthPercentage !== null ? ` (${filterHealthPercentage.toFixed(0)}%)` : '';

  switch (filterReplacementStatus) {
    case FilterReplacementStatus.FilterChangeUpcoming:
      return t('devices.status.moderate') + percentageText;
    case FilterReplacementStatus.FilterChangeOverdue:
      return t('devices.status.poor') + percentageText;
    case FilterReplacementStatus.HVACFilterAlert:
      return t('hvac.replaceFilter'); // Show "Replace Filter" for active alerts
    case FilterReplacementStatus.ServiceRequested:
      return t('hvac.serviceRequested');
    case FilterReplacementStatus.FilterOrdered:
      return t('hvac.filterOrdered');
    case FilterReplacementStatus.NoFilterChangeNeeded:
      return t('devices.status.good') + percentageText;
    default:
      return t('devices.status.good') + percentageText;
  }
};
